import React from 'react';
import { Box } from '@mui/material';

export function PlayerLayout({ children }) {
  return <Box sx={{ py: 3 }}>{children}</Box>;
}
